export const setTableFlex = {
    methods: {
        setTableHeaderFlex() {
            if (window.innerWidth < 768) return

            const siteHeader = document.querySelector('.site-header')
            if (!siteHeader) return

            const headerHeight = siteHeader.offsetHeight
            const space = 32
            setTimeout(() => {
                const lists = document.querySelectorAll('.tableFlex')
                lists.forEach(list => {
                    const header = list.querySelector('.c-thead')
                    const footerHeight =
                        list.querySelector('.c-tfooter')?.offsetHeight || 0
                    const rowHeight = list.querySelector('.c-tr')?.offsetHeight
                    const rowsLength = list.querySelectorAll('.c-tr')?.length

                    if (
                        window.innerHeight + window.scrollY >=
                        document.body.offsetHeight
                    ) {
                        return
                    }

                    if (
                        rowsLength >= 3 &&
                        list.getBoundingClientRect().top -
                            headerHeight +
                            16 -
                            space <
                            0 &&
                        list.getBoundingClientRect().bottom -
                            headerHeight -
                            space -
                            rowHeight -
                            header.offsetHeight -
                            footerHeight -
                            parseFloat(getComputedStyle(list).paddingBottom) >
                            0
                    ) {
                        list.classList.add('--fixed')
                        header.style.width = `${list.clientWidth}px`
                        header.style.top = `${headerHeight + 16}px`
                        header.style.transform = `translateX(-${parseFloat(
                            getComputedStyle(list).paddingLeft
                        )}px)`
                    } else {
                        header.style.width = 'auto'
                        header.style.transform = 'translateX(0)'
                        list.classList.remove('--fixed')
                    }
                })
            }, 0)
        },

        setTableMaxHeight() {
            const siteHeader = document.querySelector('.site-header')
            if (!siteHeader) return

            const headerHeight = siteHeader.offsetHeight
            const windowHeight = window.innerHeight
            setTimeout(() => {
                const lists = document.querySelectorAll('.tableFlex')
                lists.forEach(list => {
                    const productList = list.querySelector('.c-tbody')
                    productList.style = 'overflow-y: auto;'
                    productList.style.maxHeight = `${windowHeight -
                        headerHeight -
                        (list.offsetHeight - productList.offsetHeight)}px`
                })
            }, 0)
        }
    },
    created() {
        window.addEventListener('scroll', () => {
            this.setTableHeaderFlex()
        })
    }
}
